export default __webpack_public_path__ + "media/color/ppt-c5663390.svg";